<template>
  <div class="generateAuctionNotice">
    <h2 class="intro-y text-lg font-medium mt-10">一键转至360pai进行租赁权拍卖</h2>
    <div class="grid grid-cols-12 gap-6 mt-5">
      <div
          class="intro-y col-span-12 flex flex-wrap sm:flex-no-wrap items-center mt-2"
      >
        <button class="button text-white bg-theme-1 shadow-md mr-2"
                @click='$router.push({path:"/assetManagement/assetDetail",query:{ assetId :  form.assetId}})'>
          返回
        </button>
      </div>
    </div>
    <div class="intro-y box py-10 sm:py-20 mt-5">
      <div
          class="wizard flex flex-col lg:flex-row justify-center px-5 sm:px-20"
      >
        <div
            class="intro-x lg:text-center flex items-center lg:block flex-1 z-10"
        >
          <button class="w-10 h-10 rounded-full button text-white bg-theme-1">
            1
          </button>
          <div class="lg:w-32 font-medium text-base lg:mt-3 ml-3 lg:mx-auto">
            生成招商公告
          </div>
        </div>

        <div
            class="intro-x lg:text-center flex items-center mt-5 lg:mt-0 lg:block flex-1 z-10"
        >
          <button
              class="w-10 h-10 rounded-full button text-gray-600 bg-gray-200 dark:bg-dark-1"
          >
            2
          </button>
          <div
              class="lg:w-32 text-base lg:mt-3 ml-3 lg:mx-auto text-gray-700 dark:text-gray-600"
          >
            填写拍卖信息
          </div>
        </div>
        <div
            class="intro-x lg:text-center flex items-center mt-5 lg:mt-0 lg:block flex-1 z-10"
        >
          <button
              class="w-10 h-10 rounded-full button text-gray-600 bg-gray-200 dark:bg-dark-1"
          >
            3
          </button>
          <div
              class="lg:w-32 text-base lg:mt-3 ml-3 lg:mx-auto text-gray-700 dark:text-gray-600"
          >
            完成
          </div>
        </div>
        <div
            class="wizard__line hidden lg:block w-1/2 bg-gray-200 dark:bg-dark-1 absolute mt-5"
        ></div>
      </div>
      <div
          class="px-5 sm:px-20 mt-10 pt-10 border-t border-gray-200 dark:border-dark-5"
      >

        <el-form
            ref="ruleForm"
            :model="form"
            layout='horizontal'
            :rules="rules"
            style='width: 100%;'
        >
          <el-row :span='24'>
            <el-col :span='11' :offset='1'>
              <el-form-item label="拍品名称: " prop="name">
                <el-input v-model="form.name" placeholder="请输入拍品名称" clearable/>
              </el-form-item>
            </el-col>
            <el-col :span='11' :offset='1'>
              <el-form-item label="出租物所属行政区域: " prop="areaArray">
                <el-cascader
                    style='width: 100%;'
                    v-model="form.areaArray"
                    :options='address'
                    :props="{ label: 'name', value: 'id', children: 'children',multiple:true }"
                    placeholder="请选择出租物所属行政区域"
                />
              </el-form-item>
            </el-col>
            <el-col :span='11' :offset='1'>
              <el-form-item label="出租物详细地址: " prop="leaseAddress">
                <el-input v-model="form.leaseAddress" placeholder="请输入出租物详细地址" clearable/>
              </el-form-item>
            </el-col>
            <el-col :span='11' :offset='1'>
              <el-form-item label="资产分类: " prop="leaseType">
                <el-select v-model="form.leaseType" placeholder="请选择资产分类" clearable style='width: 100%;'>
                  <el-option :label="item.name" :value="item.id" v-for="(item,index) in leaseTypeOptions"
                             :key='item.id'>
                    {{ item.name }}
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span='11' :offset='1'>
              <el-form-item label="资产类别: " prop="areaType">
                <el-select v-model="form.areaType" placeholder="请选择资产类别" clearable style='width: 100%;'>
                  <el-option :label="item.name" :value="item.id" v-for="(item,index) in lease_area_type" :key='item.id'>
                    {{ item.name }}
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span='11' :offset='1'>
              <el-form-item label="标的面积: " prop="leaseArea" style='position: relative'>
                <el-input v-model="form.leaseArea" placeholder="请输入标的面积（保留两位小数）" clearable/>
                <div class="right-money">
                  m&sup2;
                </div>
              </el-form-item>
            </el-col>
            <el-col :span='11' :offset='1'>
              <el-form-item label="是否有证（房产证）: " prop="deedFlag">
                <el-select v-model="form.deedFlag" placeholder="请选择是否有证（房产证）" clearable style='width: 100%;'>
                  <el-option :label="item.name" :value="item.id" v-for="(item,index) in deedFlagOptions" :key='item.id'>
                    {{ item.name }}

                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span='11' :offset='1'>
              <el-form-item label="出租物间数: ">
                <el-input v-model="form.leaseRoomNumber" placeholder="请输入出租物间数" clearable/>
              </el-form-item>
            </el-col>
            <el-col :span='11' :offset='1'>
              <el-form-item label="物业公司: ">
                <el-input v-model="form.houseStructure" placeholder="请输入物业公司" clearable/>
              </el-form-item>
            </el-col>
            <el-col :span='11' :offset='1'>
              <el-form-item label="物业管理费: ">
                <el-input v-model="form.costBearer" placeholder="请输入物业管理费" clearable/>
              </el-form-item>
            </el-col>
            <el-col :span='11' :offset='1'>
              <el-form-item label="带看时间: ">
                <el-date-picker
                    style='width: 100%'
                    :value-format="dateFormat"
                    type="datetimerange"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    v-model="form.viewTime"
                    :default-time="['00:00:00', '23:59:59']"
                    clearable/>
              </el-form-item>
            </el-col>
            <el-col :span='23' :offset='1'>
              <el-form-item label="出租物图片: ">
                <el-col>
                  <imgListUpdate v-model='form.images' style='width: 100%'/>
                </el-col>
              </el-form-item>
            </el-col>
            <el-col :span='11' :offset='1'>
              <el-form-item label="实际用途: " prop='actualUse' v-if='form.deedFlag==0'>
                <el-input type='textarea' v-model="form.actualUse" placeholder="请输入实际用途" :auto-size="{ minRows: 3 }"
                          clearable/>
              </el-form-item>
            </el-col>
            <el-col :span='11' :offset='1'>
              <el-form-item label="产证用途: " prop='legalPurposes' v-if='form.deedFlag==1'>
                <el-input type='textarea' v-model="form.legalPurposes" placeholder="请输入产证用途" :auto-size="{ minRows: 3 }"
                          clearable/>
              </el-form-item>
            </el-col>
            <el-col :span='11' :offset='1'>
              <el-form-item label="产证权利人: " prop='powerSituation' v-if='form.deedFlag==1'>
                <el-input type='textarea' v-model="form.powerSituation" placeholder="请输入产证权利人"
                          :auto-size="{ minRows: 3 }" clearable/>
              </el-form-item>
            </el-col>
            <el-col :span='11' :offset='1'>
              <el-form-item label="现状描述: " prop='currentDesc'>
                <el-input type='textarea' v-model="form.currentDesc" placeholder="请输入现状描述" :auto-size="{ minRows: 3 }"
                          clearable/>
              </el-form-item>
            </el-col>

            <el-col :span='11' :offset='1'>
              <el-form-item label="资产亮点: " prop='brightSpot'>
                <el-input type='textarea' v-model="form.brightSpot" placeholder="请输入资产亮点" :auto-size="{ minRows: 3 }"
                          clearable/>
              </el-form-item>
            </el-col>

            <el-col :span='24'>
              <el-divider content-position="left">
                <div class="font-medium text-base" style='font-weight: 700;'>出租方信息</div>
              </el-divider>
            </el-col>

            <el-col :span='11' :offset='1'>
              <el-form-item label="出租方名称: ">
                <el-input v-model="form.lessorName" placeholder="请输入出租方名称" disabled/>
              </el-form-item>
            </el-col>
            <el-col :span='11' :offset='1'>
              <el-form-item label="出租方地址: ">
                <el-input v-model="form.lessorAddress" placeholder="请输入出租方地址" disabled/>
              </el-form-item>
            </el-col>
            <el-col :span='11' :offset='1'>
              <el-form-item label="出租方联系人: " prop='lessorContact'>
                <el-input v-model="form.lessorContact" placeholder="请输入出租方联系人" clearable/>
              </el-form-item>
            </el-col>
            <el-col :span='11' :offset='1'>
              <el-form-item label="出租方联系电话: " prop='lessorContactNumber'>
                <el-input v-model="form.lessorContactNumber" placeholder="请输入出租方联系电话" clearable/>
              </el-form-item>
            </el-col>
            <el-col :span='24'>
              <el-divider content-position="left">
                <div class="font-medium text-base" style='font-weight: 700;'>对竞租方资格要求</div>
              </el-divider>
            </el-col>

            <el-col :span='11' :offset='1'>
              <el-form-item label="竞租方资格: " prop="bidderQualification">
                <el-select v-model="form.bidderQualification" placeholder="请选择竞租方资格" clearable style='width: 100%;'>
                  <el-option :label="item.name" :value="item.id" v-for="(item,index) in bidderQualificationOptions"
                             :key='item.id'>
                    {{ item.name }}
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span='11' :offset='1'>
              <el-form-item label="资料预审方式: " prop="preAuditMethod">
                <el-select v-model="form.preAuditMethod" placeholder="请选择资料预审方式" clearable style='width: 100%;'>
                  <el-option :label="item.name" :value="item.id" v-for="(item,index) in preAuditMethodOptions"
                             :key='item.id'>
                    {{ item.name }}
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span='11' :offset='1'>
              <el-form-item label="原租户姓名: ">
                <el-input v-model="form.originalTenantName" placeholder="请输入原租户姓名" clearable/>
              </el-form-item>
            </el-col>
            <el-col :span='11' :offset='1'>
              <el-form-item label="原租户联系电话: ">
                <el-input v-model="form.originalTenantNumber" placeholder="请输入原租户联系电话" clearable/>
              </el-form-item>
            </el-col>
            <el-col :span='11' :offset='1'>
              <el-form-item label="优先资格: ">
                <el-input type='textarea' v-model="form.priorityQualification" placeholder="请输入优先资格"
                          :auto-size="{ minRows: 3 }"
                          clearable/>
              </el-form-item>
            </el-col>
            <el-col :span='11' :offset='1'>
              <el-form-item label="经营能力: ">
                <el-input type='textarea' v-model="form.managementCapacity" placeholder="请输入经营能力"
                          :auto-size="{ minRows: 3 }" clearable/>
              </el-form-item>
            </el-col>
            <el-col :span='11' :offset='1'>
              <el-form-item label="注册地址: ">
                <el-input type='textarea' v-model="form.registeredAddress" placeholder="请输入注册地址"
                          :auto-size="{ minRows: 3 }" clearable/>
              </el-form-item>
            </el-col>
            <el-col :span='11' :offset='1'>
              <el-form-item label="现在经营业务: ">
                <el-input type='textarea' v-model="form.businessNow" placeholder="请输入现在经营业务" :auto-size="{ minRows: 3 }"
                          clearable/>
              </el-form-item>
            </el-col>
            <el-col :span='24'>
              <el-col :span='11' :offset='1'>
                <el-form-item label="备注: ">
                  <el-input type='textarea' v-model="form.remark" placeholder="请输入备注" :auto-size="{ minRows: 3 }"
                            clearable/>
                </el-form-item>
              </el-col>
            </el-col>
            <el-col :span='24'>
              <el-divider content-position="left">
                <div class="font-medium text-base" style='font-weight: 700;'>对承租方经营出租物要求</div>
              </el-divider>
            </el-col>
            <el-col :span='11' :offset='1'>
              <el-form-item label="租赁起止期限约定: " prop='leaseTime'>
                <el-date-picker
                    style='width: 100%;'
                    :value-format="dateFormat"
                    range-separator="至"
                    type="datetimerange"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    v-model="form.leaseTime"
                    :default-time="['00:00:00', '23:59:59']"
                    clearable/>
              </el-form-item>
            </el-col>
            <el-col :span='11' :offset='1'>
              <el-form-item label="租金支付约定: " prop="paymentCycle">
                <el-select v-model="form.paymentCycle" placeholder="请选择租金支付约定" clearable style='width: 100%;'>
                  <el-option :label="item.name" :value="item.id" v-for="(item,index) in paymentCycleOptions"
                             :key='item.id'>
                    {{ item.name }}
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span='24'>
              <el-col :span='11' :offset='1'>
                <el-form-item label="出租物经营用途约定: " prop="operatingType">
                  <el-select v-model="form.operatingType" placeholder="请选择出租物经营用途约定" clearable style='width: 100%;'>
                    <el-option :label="item.name" :value="item.id" v-for="(item,index) in operatingTypeOptions"
                               :key='item.id'>
                      {{ item.name }}
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span='11' :offset='1'>
                <el-form-item label="免租期: " prop="freePeriod">
                  <el-select v-model="form.freePeriod" placeholder="请选择免租期" clearable style='width: 100%;'>
                    <el-option :label="item.name" :value="item.id" v-for="(item,index) in freePeriodOptions"
                               :key='item.id'>
                      {{ item.name }}
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-col>
            <el-col :span='11' :offset='1'>
              <el-form-item label="租金递增方式: " prop='annualIncrementRate'>
                <el-input type='textarea' v-model="form.annualIncrementRate" placeholder="请输入租金递增方式"
                          :auto-size="{ minRows: 3 }"
                          clearable/>
              </el-form-item>
            </el-col>
            <el-col :span='11' :offset='1'>
              <el-form-item label="业态约定: ">
                <el-input type='textarea' v-model="form.businessAgreement" placeholder="请输入业态约定"
                          :auto-size="{ minRows: 3 }" clearable/>
              </el-form-item>
            </el-col>
            <el-col :span='11' :offset='1'>
              <el-form-item label="装饰和改变房屋结构约定: ">
                <el-input type='textarea' v-model="form.houseStructureAgreement" placeholder="请输入装饰和改变房屋结构约定"
                          :auto-size="{ minRows: 3 }"
                          clearable/>
              </el-form-item>
            </el-col>
            <el-col :span='11' :offset='1'>
              <el-form-item label="维修养护约定: ">
                <el-input type='textarea' v-model="form.maintainAgreement" placeholder="请输入维修养护约定约定"
                          :auto-size="{ minRows: 3 }"
                          clearable/>
              </el-form-item>
            </el-col>
            <el-col :span='11' :offset='1'>
              <el-form-item label="综合治理和安全责任约定: ">
                <el-input type='textarea' v-model="form.safetyAgreement" placeholder="请输入综合治理和安全责任约定"
                          :auto-size="{ minRows: 3 }"
                          clearable/>
              </el-form-item>
            </el-col>
            <el-col :span='11' :offset='1'>
              <el-form-item label="其他约定: ">
                <el-input type='textarea' v-model="form.lesseeOtherAgreement" placeholder="请输入其他约定"
                          :auto-size="{ minRows: 3 }" clearable/>
              </el-form-item>
            </el-col>
            <el-col :span='24' :offset='1'>
              <el-divider content-position="left">
                <div class="font-medium text-base" style='font-weight: 700;'>其他合同要约</div>
              </el-divider>
            </el-col>

            <el-col :span='11' :offset='1'>
              <el-form-item label="征收约定: ">
                <el-input type='textarea' v-model="form.levyAgreement" placeholder="请输入征收约定" :auto-size="{ minRows: 3 }"
                          clearable/>
              </el-form-item>
            </el-col>
            <el-col :span='11' :offset='1'>
              <el-form-item label="续租约定: ">
                <el-input type='textarea' v-model="form.renewalAgreement" placeholder="请输入续租约定"
                          :auto-size="{ minRows: 3 }" clearable/>
              </el-form-item>
            </el-col>
            <el-col :span='11' :offset='1'>
              <el-form-item label="终止合同约定: ">
                <el-input type='textarea' v-model="form.terminationContractAgreement" placeholder="请输入终止合同约定"
                          :auto-size="{ minRows: 3 }"
                          clearable/>
              </el-form-item>
            </el-col>
            <el-col :span='11' :offset='1'>
              <el-form-item label="争议处理约定: ">
                <el-input type='textarea' v-model="form.disputeResolutionAgreement" placeholder="请输入争议处理约定"
                          :auto-size="{ minRows: 3 }"
                          clearable/>
              </el-form-item>
            </el-col>
            <el-col :span='11' :offset='1'>
              <el-form-item label="违约责任约定: ">
                <el-input type='textarea' v-model="form.defaultLiabilityAgreement" placeholder="请输入违约责任约定"
                          :auto-size="{ minRows: 3 }"
                          clearable/>
              </el-form-item>
            </el-col>
            <el-col :span='11' :offset='1'>
              <el-form-item label="其他约定: ">
                <el-input type='textarea' v-model="form.contractOtherAgreement" placeholder="请输入其他约定"
                          :auto-size="{ minRows: 3 }"
                          clearable/>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <div
          class="intro-y col-span-12 flex items-center justify-center sm:justify-end mt-5"
          style='padding-right: 5rem;'
      >
        <el-button
            @click='handleSubmit(0)'
        >
          暂存
        </el-button>
        <el-button
            type="primary"
            @click='handleSubmit(1)'
        >
          预览招商公告
        </el-button>
      </div>
    </div>
  </div>
</template>

<script>
import {mapState} from 'vuex'
import {saveAuction} from "../../../../api/asset";
import imgListUpdate from "../../../../components/imgListUpdate";

export default {
  name: "generateAuctionNotice",
  components: {
    imgListUpdate,
  },
  data() {
    let checkNumber = (rule, value, callback) => {
      let numberReg = /^[0-9]{1}\d*(\.\d{1,2})?$/
      if (numberReg.test(value)) {
        callback()
      } else {
        callback(new Error(rule.message));
      }
    };
    let checkTime = (rule, value, callback) => {
      if (value[0] && value[1]) {
        callback()
      } else {
        callback(new Error(rule.message));
      }
    };


    return {

      form: {},
      loading: false,
      rules: {
        name: [
          {required: true, message: '请输入拍品名称', trigger: 'blur'},
        ],
        leaseAddress: [
          {required: true, message: '请输入出租物详细地址', trigger: 'blur'},
        ],
        leaseType: [
          {required: true, message: '请选择资产分类', trigger: 'change'},
        ],
        areaType: [
          {required: true, message: '请选择资产类别', trigger: 'change'},
        ],
        leaseArea: [
          {required: true, message: '请输入正确的标的面积（保留两位小数）', validator: checkNumber, trigger: 'blur'},
        ],
        deedFlag: [
          {required: true, message: '请选择是否有证（房产证）', trigger: 'change'},
        ],
        actualUse: [
          {required: true, message: '请输入实际用途', trigger: 'blur'},
        ],
        legalPurposes: [
          {required: true, message: '请输入产证用途', trigger: 'blur'},
        ],
        powerSituation: [
          {required: true, message: '请输入产证权利人', trigger: 'blur'},
        ],
        lessorContact: [
          {required: true, message: '请输入出租方联系人', trigger: 'blur'},
        ],
        lessorContactNumber: [
          {required: true, message: '请输入出租方联系电话', trigger: 'blur'},
        ],
        bidderQualification: [
          {required: true, message: '请选择竞租方资格', trigger: 'change'},
        ],
        preAuditMethod: [
          {required: true, message: '请选择资料预审方式', trigger: 'change'},
        ],
        leaseTime: [
          {required: true, validator: checkTime, message: '请选择租赁起止期限约定', trigger: 'change'},
        ],
        paymentCycle: [
          {required: true, message: '请选择租金支付约定', trigger: 'change'},
        ],
        operatingType: [
          {required: true, message: '请选择出租物经营用途约定', trigger: 'change'},
        ],
        freePeriod: [
          {required: true, message: '请选择免租期', trigger: 'change'},
        ],
        annualIncrementRate: [
          {required: true, message: '请输入租金递增方式', trigger: 'blur'},
        ],
      },
    }
  },
  methods: {
    handleSubmit(stepStatus) {
      console.log(this.form.leaseTime);
      this.$refs['ruleForm'].validate(valid => {
        if (valid) {
          let para = Object.assign({}, this.form)
          let areaArray = []
          for (let i = 0; i < para.areaArray.length; i++) {
            areaArray.push({
              provinceId: para.areaArray[i][0] || '',
              id: para.areaArray[i][1] || '',
              areaId: para.areaArray[i][2] || '',
              townId: para.areaArray[i][3] || '',
            })
          }
          para.areaArray = areaArray
          para.leaseStartTime = para.leaseTime[0] || ''
          para.leaseEndTime = para.leaseTime[1] || ''
          para.viewBeginTime = para.viewTime[0] || ''
          para.viewEndTime = para.viewTime[1] || ''
          para.stepStatus = stepStatus
          let images = para.images
          let arr = []
          for (let i = 0; i < images.length; i++) {
            if(images[i].url){
              arr.push(images[i].url)
            }
          }
          para.extra = {}
          para.extra.images = arr
          saveAuction(para).then(res => {
            let data = res.data
            if (data.code === '000') {
              if (stepStatus == 1) {
                this.$message.success('提交发布成功')
                this.$store.dispatch('setAuctionForm', para)
                this.$router.push({path: '/assetManagement/auctionNoticePreview'})
              } else {
                console.log('暂存？')
                this.$store.dispatch('setAuctionForm', para)
                this.$message.success('暂存成功')
              }

            } else {
              this.$message.error(data.desc)
            }
          }).catch(err => {
            console.log(err);
          }).finally(() => {

          })


        } else {
          this.$message.error('请填写必填信息')
          console.log('error submit!!');
          return false;
        }
      });
    },
  },
  created() {
    this.form = Object.assign({}, this.forms)
  },
  computed: {
    ...mapState({
      address: state => state.public.address,
      leaseTypeOptions: state => state.public.leaseTypeOptions,
      operatingTypeOptions: state => state.public.operatingTypeOptions,
      freePeriodOptions: state => state.public.freePeriodOptions,
      areaTypeOptions: state => state.public.areaTypeOptions,
      deedFlagOptions: state => state.public.deedFlagOptions,
      bidderQualificationOptions: state => state.public.bidderQualificationOptions,
      preAuditMethodOptions: state => state.public.preAuditMethodOptions,
      paymentCycleOptions: state => state.public.paymentCycleOptions,
      lease_area_type: state => state.public.lease_area_type,
      dateFormat: state => state.public.dateFormat,
      forms: state => state.auction.form,
    }),
  },
}
</script>
<style scoped lang="scss">
.right-money {
  color: #333;
  font-size: 14px;
  padding-left: 20px;
  white-space: nowrap;
  cursor: pointer;
  position: absolute;
  right: 0;
  top: 0;
}
</style>
